// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__PrJM0","info":"Note_info__OV86W","note":"Note_note__1DE8F","actions":"Note_actions__9IuFL"};